import {MessageService} from 'app/services/messages.service';
import {SnackBarService} from './../../../../services/snackbar.service';
import {ConstantsService} from './../../../../services/constants-service';
import {Component} from '@angular/core';
import {CookieService} from 'app/services/cookie.service';
import {
  EntityRelationsService,
  RelationshipPanelActions
} from 'app/entities/relations/entity-relations.service';

@Component({
  moduleId: module.id,
  selector: 'import-relation',
  templateUrl: 'import-relation.component.html',
  styleUrls: ['import-relation.component.css']
})
export class ImportRelationComponent {
  enableSubmitButton: boolean = false;
  fileEvent: any;
  entityId: any;
  filename: string = null;

  constructor(private snackBarService: SnackBarService,
              private cookieService: CookieService,
              private entityRelationsService: EntityRelationsService) {
  }

  fileChange(event) {
    this.fileEvent = event;
    this.enableSubmitButton = this.entityId != null;
    this.filename = this.fileEvent.target.files['0'].name;
  }

  uploadFile() {
    let fileList: FileList = this.fileEvent.target.files;
    this.entityRelationsService.sendMessage(RelationshipPanelActions.LOADING_FILE.toString());
    if (fileList.length > 0) {
      let file: File = fileList[0];

      let formData: FormData = new FormData();
      formData.append('entityId', this.entityId);
      formData.append('relationships', file, file.name);
      const url = ConstantsService.APP_BE_URL + ConstantsService.SERVLET_RELATION_UPLOAD;
      let xhr: XMLHttpRequest = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.callSnackBarService(JSON.parse(xhr.response));
            this.entityRelationsService.sendMessage(RelationshipPanelActions.UPDATE_RELATIONSHIPS.toString());
            this.enableSubmitButton = false;
          } else {
            this.entityRelationsService.sendMessage(RelationshipPanelActions.STOP_LOADING_FILE.toString());
            this.entityRelationsService.sendMessage(RelationshipPanelActions.UPDATE_RELATIONSHIPS.toString());
            this.callSnackBarService(JSON.parse(xhr.response));
          }
        }
      };

      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization',
        'Bearer ' + this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN));
      xhr.withCredentials = true;
      xhr.setRequestHeader('app-type', 'TRUST');
      xhr.send(formData);
    }
  }

  private callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response, MessageService.UPLOAD_FILE_SUCCESS, MessageService.UPLOAD_FILE_FAILURE);
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/import-relation/import-relation.component.ts